import React, { useState, useEffect } from "react";
import {
  Page,
  Card,
  Text,
  InlineStack,
  BlockStack,
  Avatar,
  Badge,
  Box,
  Divider,
  InlineGrid,
  Spinner,
  Select,
  FormLayout,
  Button,
  ButtonGroup,
  Tooltip,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { CategoriesIcon } from "@shopify/polaris-icons";

export default function Teams() {
  const [departments, setDepartments] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [optionsDepartments, setOptionsDepartments] = useState([]);
  const [departmentFilter, setDepartmentFilter] = useState("All");

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get(`/departments?all`);
        const data = response?.data?.data;

        const options = [
          { label: "All", value: "All" },
          ...data.map((dept) => ({
            label: dept.name,
            value: dept.id,
          })),
        ];

        setOptionsDepartments(options);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };

    fetchDepartments();
  }, []);
  const [total, setTotal] = useState("");
  useEffect(() => {
    setIsLoading(true);
    const params = new URLSearchParams();
    if (departmentFilter !== "All")
      params.append("filter[id]", departmentFilter);
    axios
      .get("/departments?with_people", { params }) // ✅ keep your exact API endpoint
      .then((res) => {
        // Your response seems to be an array of departments
        const data =
          res?.data?.data?.data || // if it's paginated like Laravel API Resource
          res?.data?.data ||
          res?.data ||
          [];
        const filtered = data.filter(
          (dept) => Array.isArray(dept.people) && dept.people.length > 0,
        );
        setDepartments(filtered);
        setTotal(
          filtered.reduce(
            (sum, department) => sum + department.people.length,
            0,
          ),
        );
      })
      .catch((err) => {
        console.error("Error fetching team data:", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [departmentFilter]);

  //   if (isLoading) {
  //     return (
  //       <Page title="Teams Members" fullWidth>
  //         <Box padding="800" align="center" minHeight="50vh">
  //           <Spinner accessibilityLabel="Loading teams" size="large" />
  //         </Box>
  //       </Page>
  //     );
  //   }
  const [layout, setLayout] = useState("Normal");
  const formatName = (name) => {
    const parts = name.split(/[\s-]+/); // split by space or dash

    if (parts.length > 1) {
      return `${parts[0]} ${parts[1][0]}.`;
    }

    return parts[0];
  };
  return departments ? (
    <Page
      title={`Team Members (${total})`}
      fullWidth
      backAction={{
        onAction: () => navigate(`/admin/projects`),
      }}
      secondaryActions={
        <Button
          onClick={() => navigate("/admin/projects")}
          icon={CategoriesIcon}
        >
          Projects
        </Button>
      }
    >
      <FormLayout>
        <Card>
          <BlockStack gap="500">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center", // 👈 vertically center both sides
                flexWrap: "wrap",
                gap: "1rem",
              }}
            >
              <ButtonGroup segmented>
                {optionsDepartments.map((t) => (
                  <Button
                    key={t.value}
                    pressed={String(departmentFilter) === String(t.value)}
                    onClick={() => setDepartmentFilter(String(t.value))}
                  >
                    {t.label}
                  </Button>
                ))}
              </ButtonGroup>
              {/* <InlineStack gap="300" wrap align="center">
                <Select
                  label="Department"
                  value={departmentFilter}
                  onChange={setDepartmentFilter}
                  options={optionsDepartments}
                />
              </InlineStack> */}

              {/* 🔹 Right side: ButtonGroup */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center", // 👈 centers vertically
                }}
              >
                <ButtonGroup variant="segmented">
                  {["Compact", "Normal"].map((label) => (
                    <Button
                      key={label}
                      pressed={layout === label}
                      onClick={() => setLayout(label)}
                    >
                      {label}
                    </Button>
                  ))}
                </ButtonGroup>
              </div>
            </div>
          </BlockStack>
        </Card>

        {departments?.length ? (
          <BlockStack gap="800">
            {departments.length === 0 ? (
              <Text tone="subdued">No team data found.</Text>
            ) : (
              departments.map((dept) => (
                <BlockStack key={dept.id} gap="300">
                  {/* Department Title */}
                  <InlineStack align="start" gap="200">
                    <Text as="h2" variant="headingMd" fontWeight="semibold">
                      {dept.name}{" "}
                    </Text>
                    <Box paddingBlock="0" paddingInline="0" as="span">
                      <Text as="span" tone="subdued" variant="bodySm">
                        {dept.people?.length || 0} member
                        {dept.people?.length > 1 ? "s" : ""}
                      </Text>
                    </Box>
                  </InlineStack>
                  {/* <Text>
                    {dept.name}{" "}
                    <Text tone="subdued" as="span">
                      {dept.people?.length || 0} member
                      {dept.people?.length > 1 ? "s" : ""}
                    </Text>
                  </Text> */}

                  {/* Members Grid */}
                  {dept.people?.length ? (
                    layout === "Normal" ? (
                      <Box
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fill, minmax(300px, 1fr))",
                          gap: "1rem",
                          justifyContent: "center",
                        }}
                      >
                        {dept.people.map((person) => (
                          <Card key={person.id} padding="200">
                            <Box
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center", // ✅ centers the projects box vertically
                                gap: "1rem",
                                flexWrap: "nowrap", // prevent wrapping
                              }}
                            >
                              {/* LEFT SIDE - Profile Info */}
                              <Box
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "left",
                                  justifyContent: "center",
                                  textAlign: "center",
                                  gap: "0.2rem",
                                  flex: "0 0 50px", // ✅ thinner left column
                                }}
                              >
                                {/* <Badge tone="critical">Full</Badge> */}
                                {/* Custom circular avatar (slightly smaller) */}
                                <div
                                  style={{
                                    position: "relative", // make this container relative
                                    width: "50px",
                                    height: "50px",
                                  }}
                                >
                                  {/* Circular image */}
                                  <div
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      borderRadius: "50%",
                                      overflow: "hidden",
                                      border: "2px solid #e1e3e5",
                                      backgroundColor: "#f6f6f7",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <img
                                      src={person.image_url || ""}
                                      alt={person.name}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </div>

                                  {/* Polaris badge positioned on bottom-right */}
                                  <div
                                    style={{
                                      position: "absolute",
                                      bottom: "-5px",
                                      right: "-5px",
                                      zIndex: 10, // ensures it stays above the image
                                    }}
                                  >
                                    <Badge
                                      tone={
                                        person?.status?.description === "Busy"
                                          ? "critical"
                                          : "info"
                                      }
                                      size="small"
                                    >
                                      {person?.status?.description || "Free"}
                                    </Badge>
                                  </div>
                                </div>

                                {/* Name, role, and status */}
                                <Box>
                                  {/* <Text
                                    variant="bodyMd"
                                    fontWeight="semibold"
                                    breakWord
                                  >
                                    {person.name}
                                  </Text> */}
                                  <div
                                    style={{
                                      maxWidth: "100%",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Text
                                      variant="bodyMd"
                                      fontWeight="semibold"
                                    >
                                      {formatName(person.name.split(" ")[0])}
                                    </Text>
                                  </div>
                                  {/* <Text tone="subdued">
                                    {person.person_role || "—"}
                                  </Text> */}
                                </Box>
                              </Box>
                              {/* RIGHT SIDE - Projects */}
                              <Box
                                style={{
                                  backgroundColor: "#f9fafb",
                                  border: "0.5px solid #e5e7eb",
                                  borderRadius: "8px",
                                  padding: "0.5rem",
                                  flex: 1,
                                  height: "90px", // 👈 fixed height
                                  overflowY: "auto", // 👈 scrolls when too many projects
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "0.2rem",
                                }}
                              >
                                {person.projects?.length ? (
                                  person.projects.map((project) => (
                                    <Box
                                      key={project.id}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "0.5rem",
                                      }}
                                    >
                                      <Avatar
                                        source={project.logo || ""}
                                        name={project.name}
                                        size="xs"
                                      />
                                      <div
                                        style={{
                                          minWidth: 0,
                                          maxWidth: 200,
                                          overflow: "hidden",
                                        }}
                                      >
                                        <Text
                                          variant="bodyMd"
                                          as="span"
                                          truncate
                                        >
                                          <span style={{ fontSize: "10px" }}>
                                            {project.name}
                                          </span>
                                        </Text>
                                      </div>
                                    </Box>
                                  ))
                                ) : (
                                  <Box style={{ color: "#dddedf" }}>
                                    <Text
                                      variant="bodySm"
                                      tone="subdued"
                                      as="span"
                                    >
                                      No projects assigned
                                    </Text>
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          </Card>
                        ))}
                      </Box>
                    ) : (
                      // <Box
                      //   style={{
                      //     display: "grid",
                      //     gridTemplateColumns: "repeat(3, 1fr)", // 3 equal columns
                      //     gap: "1rem",
                      //     width: "100%",
                      //   }}
                      // >
                      //   {dept.people.map((person) => (
                      //     <Card
                      //       key={person.id}
                      //       padding="400"
                      //       style={{
                      //         width: "100%",
                      //         backgroundColor: "#fff",
                      //         border: "1px solid #e5e7eb",
                      //         display: "flex",
                      //         alignItems: "center",
                      //         justifyContent: "flex-start",
                      //         gap: "1.5rem",
                      //         height: "100%",
                      //       }}
                      //     >
                      //       {/* LEFT: Avatar + Name (stacked) */}
                      //       <Box
                      //         style={{
                      //           display: "flex",
                      //           flexDirection: "column",
                      //           alignItems: "center",
                      //           justifyContent: "center",
                      //           textAlign: "center",
                      //           flex: "0 0 100px",
                      //           gap: "0.4rem",
                      //         }}
                      //       >
                      //         <div
                      //           style={{
                      //             position: "relative",
                      //             width: "64px",
                      //             height: "64px",
                      //           }}
                      //         >
                      //           <img
                      //             src={person.image_url || ""}
                      //             alt={person.name}
                      //             style={{
                      //               width: "100%",
                      //               height: "100%",
                      //               borderRadius: "50%",
                      //               objectFit: "cover",
                      //               border: "2px solid #f0f0f0",
                      //             }}
                      //           />
                      //           <Badge
                      //             tone={
                      //               person.status?.description === "Full"
                      //                 ? "critical"
                      //                 : person.status?.description === "Busy"
                      //                 ? "attention"
                      //                 : "success"
                      //             }
                      //             style={{
                      //               position: "absolute",
                      //               bottom: "-8px",
                      //               left: "50%",
                      //               transform: "translateX(-50%)",
                      //               fontSize: "10px",
                      //               padding: "0 6px",
                      //             }}
                      //           >
                      //             {person.status?.description || "Busy"}
                      //           </Badge>
                      //         </div>

                      //         <Text
                      //           variant="bodyMd"
                      //           fontWeight="medium"
                      //           style={{
                      //             textAlign: "center",
                      //             marginTop: "0.5rem",
                      //           }}
                      //         >
                      //           {person.name}
                      //         </Text>
                      //       </Box>

                      //       {/* RIGHT: Projects aligned horizontally */}
                      // <Box
                      //   style={{
                      //     display: "flex",
                      //     flexWrap: "wrap",
                      //     alignItems: "center",
                      //     gap: "8px",
                      //     flex: 1,
                      //     justifyContent: "flex-start",
                      //   }}
                      // >
                      //   {person.projects?.length ? (
                      //     person.projects.map((project) => (
                      //       <Avatar
                      //         key={project.id}
                      //         source={project.logo || ""}
                      //         name={project.name}
                      //         size="sm"
                      //       />
                      //     ))
                      //   ) : (
                      //     <Text tone="subdued" variant="bodySm">
                      //       —
                      //     </Text>
                      //   )}
                      // </Box>
                      //     </Card>
                      //   ))}
                      // </Box>
                      <Box
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(5, 1fr)", // 👈 now 5 columns per row
                          gap: "1rem",
                          width: "100%",
                        }}
                      >
                        {dept.people.map((person) => (
                          <Card key={person.id} padding="200">
                            <Box
                              style={{
                                display: "flex",
                                justifyContent: "flex-start", // keep them side by side
                                alignItems: "center", // ✅ centers the projects box vertically
                                gap: "1rem",
                                flexWrap: "nowrap", // prevent wrapping
                              }}
                            >
                              {/* LEFT SIDE - Profile Info */}
                              <Box
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  textAlign: "center",
                                  gap: "0.1rem",
                                  flex: "0 0 50px", // ✅ thinner left column
                                }}
                              >
                                <div
                                  style={{
                                    position: "relative", // make this container relative
                                    width: "50px",
                                    height: "50px",
                                  }}
                                >
                                  {/* Circular image */}
                                  <div
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      borderRadius: "50%",
                                      overflow: "hidden",
                                      border: "2px solid #e1e3e5",
                                      backgroundColor: "#f6f6f7",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <img
                                      src={person.image_url || ""}
                                      alt={person.name}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </div>

                                  {/* Polaris badge positioned on bottom-right */}
                                  <div
                                    style={{
                                      position: "absolute",
                                      bottom: "-5px",
                                      right: "-5px",
                                      zIndex: 10, // ensures it stays above the image
                                    }}
                                  >
                                    <Badge tone="critical" size="small">
                                      Full
                                    </Badge>
                                  </div>
                                </div>

                                {/* Name, role, and status */}
                                <Box>
                                  <div
                                    style={{
                                      maxWidth: "100%",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      textAlign: "center",
                                    }}
                                    // title={person.name} // ✅ shows full name on hover
                                  >
                                    <Text
                                      variant="bodyMd"
                                      fontWeight="semibold"
                                    >
                                      {formatName(person.name.split(" ")[0])}
                                    </Text>
                                  </div>
                                  {/* <Text tone="subdued">
                                    {person.person_role || "—"}
                                  </Text> */}
                                </Box>
                              </Box>
                              {/* RIGHT SIDE - Projects */}
                              {/* <Box
                                style={{
                                  display: "grid",
                                  gridAutoFlow: "column", // 👈 fill columns horizontally
                                  gridTemplateRows: "repeat(2, auto)", // 👈 2 rows per column
                                  gap: "8px 12px",
                                  flex: 1,
                                  alignItems: "start",
                                  justifyItems: "center",
                                }}
                              > */}
                              <Box
                                style={{
                                  backgroundColor: "#f9fafb",
                                  border: "0.5px solid #e5e7eb",
                                  borderRadius: "8px",
                                  padding: "0.5rem",
                                  flex: 1,
                                  height: "70px", // ✅ same fixed height as Normal
                                  overflowY: "auto", // ✅ scrollable if too many projects
                                  display: "grid",
                                  gridTemplateColumns: "repeat(3, 1fr)", // ✅ max 3 columns
                                  gap: "8px 12px",
                                  alignItems: "start",
                                  justifyItems: "center",
                                }}
                              >
                                {person.projects?.length ? (
                                  person.projects.map((project) => (
                                    <Tooltip
                                      key={project.id}
                                      content={project.name}
                                    >
                                      <div style={{ cursor: "pointer" }}>
                                        <Avatar
                                          source={project.logo || ""}
                                          name={project.name}
                                          size="sm"
                                        />
                                      </div>
                                    </Tooltip>
                                  ))
                                ) : (
                                  <Text tone="subdued" variant="bodySm">
                                    —
                                  </Text>
                                )}
                              </Box>
                            </Box>
                          </Card>
                        ))}
                      </Box>
                    )
                  ) : (
                    <Text tone="subdued" variant="bodySm">
                      No people in this department.
                    </Text>
                  )}
                </BlockStack>
              ))
            )}
          </BlockStack>
        ) : (
          <Card>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div style={{ width: "25%" }}>
                <img src={emptyListImage} alt="No results" />
              </div>
              <div className="mb-3">
                <Text variant="headingLg" as="h5" color="subdued">
                  No results found
                </Text>
              </div>
            </div>
          </Card>
        )}
        {/* <Box paddingBlock="500">
        <Divider />
      </Box> */}
      </FormLayout>
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
}
